import React, { useState, forwardRef } from 'react'
import { Input } from 'antd'
import PhoneInputWithoutContrySelect from 'react-phone-number-input/input'
import SSNInput from '../SSNInput'
import './MaterialInput.css'

const MaterialInput = forwardRef(
  (
    {
      className,
      errorText,
      iconClassName,
      containerClassName = '',
      hideLabel,
      ...others
    },
    ref
  ) => {
    let { label, type, required, value = '', placeholder } = others
    const [focus, setFocus] = useState(false)
    const requiredMark = required ? (
      <span className='text-danger'>*</span>
    ) : null
    const hasIcon = !!iconClassName

    const isPassword = type === 'password'
    const isPhone = type === 'phone'
    const isSSN = type === 'ssn'
    const isNumber = type === 'number'

    return (
      <div
        className={
          errorText
            ? 'material-outline-input-container error ' + containerClassName
            : 'material-outline-input-container ' + containerClassName
        }
      >
        <div
          className={
            hasIcon ? 'material-textfield with-icon' : 'material-textfield'
          }
          onBlur={() => setFocus(false)}
          onFocus={() => setFocus(true)}
        >
          {!isPassword && !isPhone && !isSSN && (
            <input
              ref={ref}
              placeholder={placeholder}
              className={className}
              type={type}
              onKeyDown={e =>
                isNumber
                  ? ['e', 'E', '+', '-', '.'].includes(e.key) &&
                    e.preventDefault()
                  : {}
              }
              value={value || ''}
              {...others}
            />
          )}
          {isPassword && (
            <Input.Password
              type={type}
              value={value || ''}
              placeholder={placeholder}
              className={'input ' + className}
              {...others}
            />
          )}
          {isSSN && (
            <SSNInput
              type={type}
              value={value || ''}
              placeholder={placeholder}
              className={'input ' + className}
              {...others}
            />
          )}
          {isPhone && (
            <PhoneInputWithoutContrySelect
              placeholder={placeholder}
              value={value || ''}
              {...others}
            />
          )}
          {hasIcon && <span className={'input-icon ' + iconClassName} />}
          {!hideLabel && (
            <label
              className={
                value || placeholder || others.forceMinimizeLabel || focus
                  ? 'with-value'
                  : ''
              }
            >
              {label}
              {requiredMark}
            </label>
          )}
        </div>
        <div className='error'> {errorText} </div>
      </div>
    )
  }
)

export default MaterialInput
